var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.onVisibilityChanged,
          expression: "onVisibilityChanged"
        }
      ],
      staticClass: "home-how-it-works-steps-container"
    },
    [
      _c("div", { staticClass: "home-how-it-works-steps desktop-only" }, [
        _c(
          "div",
          { staticClass: "screens" },
          [_c("home-steps-screen-carousel", { attrs: { index: _vm.index } })],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("h2", [_vm._v(_vm._s(_vm.$t("home.how-it-works")))]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "pills" },
            _vm._l(5, function(i) {
              return _c(
                "li",
                {
                  key: i,
                  class: { active: i === _vm.index },
                  on: {
                    click: function($event) {
                      _vm.navigateTo(i)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "order" }, [
                    _c("span", [_vm._v(_vm._s(i))])
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "step-label",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("home.how-it-works-" + i))
                    }
                  })
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "home-how-it-works-stores-container" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("home.download-app")))]),
            _vm._v(" "),
            _c("div", { staticClass: "home-how-it-works-stores" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://apps.apple.com/us/app/openfly/id1450925351",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/imgs/ios-download-" + _vm.locale + ".webp" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://play.google.com/store/apps/details?id=com.airaffaires.pro",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/imgs/android-download-" + _vm.locale + ".webp"
                    }
                  })
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-how-it-works-steps mobile-only" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.$t("home.how-it-works")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "screens" },
            [_c("home-steps-screen-carousel", { attrs: { index: _vm.index } })],
            1
          ),
          _vm._v(" "),
          _c("DotNavigation", {
            attrs: { "page-count": 5, value: _vm.index },
            on: {
              input: function($event) {
                _vm.navigateTo($event)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dot-navigation" },
            _vm._l(5, function(i) {
              return _c("div", {
                key: i,
                class: { active: i === _vm.index },
                on: {
                  click: function($event) {
                    _vm.navigateTo(i)
                  }
                }
              })
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "carousel",
            {
              staticClass: "pills_carrousel",
              attrs: {
                autoplay: _vm.isVisible && _vm.autoplay,
                "autoplay-hover-pause": "",
                "autoplay-timeout": 3000,
                "per-page": 1,
                "pagination-enabled": false,
                "center-mode": "",
                loop: "",
                "navigate-to": _vm.index - 1
              },
              on: {
                input: function($event) {
                  _vm.onCarouselInput($event)
                }
              }
            },
            _vm._l(5, function(i) {
              return _c("slide", { key: i }, [
                _c("div", { staticClass: "pills_container" }, [
                  _c("div", {
                    staticClass: "content",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("home.how-it-works-" + i))
                    }
                  })
                ])
              ])
            }),
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "home-how-it-works-stores-container" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("home.download-app")))]),
            _vm._v(" "),
            _c("div", { staticClass: "home-how-it-works-stores" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://apps.apple.com/us/app/openfly/id1450925351",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/imgs/ios-download-" + _vm.locale + ".webp" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://play.google.com/store/apps/details?id=com.airaffaires.pro",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/imgs/android-download-" + _vm.locale + ".webp"
                    }
                  })
                ]
              )
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-145c692d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145c692d","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HomeStepsScreen.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-145c692d","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HomeStepsScreen.vue
// module chunks = 1 2 3